import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=ee8311b8&scoped=true&"
import script from "./logout.vue?vue&type=script&lang=ts&"
export * from "./logout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8311b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee8311b8')) {
      api.createRecord('ee8311b8', component.options)
    } else {
      api.reload('ee8311b8', component.options)
    }
    module.hot.accept("./logout.vue?vue&type=template&id=ee8311b8&scoped=true&", function () {
      api.rerender('ee8311b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logout.vue"
export default component.exports